import { useEffect, useMemo } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';
import { BASE_URL } from '../config';

export const useAxios = () => {
  const { token, refresh, logout } = useAuth();

  // 1. axiosInstance sadece bir kere oluşturulsun
  const axiosInstance = useMemo(() => {
    return axios.create({
      baseURL: BASE_URL,
    });
  }, []);

  // 2. Token değiştikçe interceptors yeniden ayarlanır
  useEffect(() => {
    const requestInterceptor = axiosInstance.interceptors.request.use(
      (config) => {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      async (error) => {
        const originalRequest = error.config;

        // 3. 401 durumunda refresh denensin
        if (error.response?.status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;

          const success = await refresh?.();
          if (success) {
            const newAccessToken = localStorage.getItem('accessToken');
            if (newAccessToken) {
              originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
              return axiosInstance(originalRequest); // retry
            }
          }

          // refresh başarısızsa logout
          await logout?.();
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axiosInstance.interceptors.request.eject(requestInterceptor);
      axiosInstance.interceptors.response.eject(responseInterceptor);
    };
  }, [token, refresh, logout]);

  return axiosInstance;
};